function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M57,6.3v32.9H2.5V6.3H57 M60,3.3H-0.5v38.9H60V3.3L60,3.3z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M25,17.1l9.1,4.5L25,26.8V17 M22,12.3v19.6l18.5-10.4L22,12.3L22,12.3z"
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  y: 51,
  width: 16,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 23,
  y: 51,
  width: 37,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M21.7,48.8v5.9h-5.9v-5.9H21.7 M24.7,45.8H12.8v11.9h11.9V45.8L24.7,45.8z"
}))))));

var SvgVideo = function SvgVideo(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/video.849d56b4.svg";
export { SvgVideo as ReactComponent };